import { ToastStatus } from "./ActiveStudentPhrase";
import {
  MediaRecorder,
  IMediaRecorder,
  register,
} from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";

(async function init() {
  await register(await connect());
})();

export interface RecordingTools {
  mediaRecorder: IMediaRecorder;
  analyser: AnalyserNode;
}

export const createRecordingTools = async (
  customToast: (title: string, description: string, status: ToastStatus) => void
): Promise<RecordingTools | undefined> => {
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: {
          sampleRate: 11025,
          sampleSize: 16,
          channelCount: 1,
        },
      });
      const audioCtx = new AudioContext();
      const analyser = audioCtx.createAnalyser();
      analyser.fftSize = 2048;
      const source = audioCtx.createMediaStreamSource(stream);
      source.connect(analyser);
      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: "audio/wav",
      });
      return { analyser, mediaRecorder };
    } catch (error: any) {
      if (error.name === "NotAllowedError") {
        customToast(
          "Permission error",
          "You must allow this site to use your microphone to continue",
          "warning"
        );
      } else {
        customToast(
          "Unexpected error",
          `The following getUserMedia error occurred: ${error}`,
          "error"
        );
      }
    }
  } else {
    customToast(
      "Browser not supported",
      "getUserMedia is not supported on your browser",
      "error"
    );
  }
  return undefined;
};
